import { Modal } from "components/modal/Modal";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectAuthStatus, signOut } from "reducers/auth";
import Verification from "./Verification/Verification";
import { selectVerificationStatus } from "reducers/verification";
import Page from "components/Page";
import { selectUserInfo } from "reducers/userInfo";

type Props = {};

export const OnboardingModal = (props: Props) => {
  const dispatch = useDispatch();
  const authStatus = useSelector(selectAuthStatus);
  const isSignedIn = authStatus === "signed_in";
  const { bVerified } = useSelector(selectVerificationStatus);
  const { userInfo } = useSelector(selectUserInfo);

  if (userInfo?.userType !== "VenueGroup") return null;

  if (bVerified && isSignedIn) return null;

  return (
    <Page>
      <Modal
        title="Venue Group Verification"
        open={!bVerified && isSignedIn}
        fullSize={true}
        closeModal={() => {}}
        className="VerificationModal"
        disableFooter
        customCloseButton={
          <div className="RightHeader">
            <span className="SignOutLink" onClick={() => dispatch(signOut())}>
              Sign out
            </span>
          </div>
        }
      >
        <Verification />
      </Modal>
    </Page>
  );
};
